import { render, staticRenderFns } from "./NewDistributor.vue?vue&type=template&id=1cd3e2a8&scoped=true&"
import script from "./NewDistributor.vue?vue&type=script&lang=js&"
export * from "./NewDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd3e2a8",
  null
  
)

export default component.exports